import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import addIcon from "../../assets/images/addSm.svg";
import minusIcon from "../../assets/images/minusIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { ChargesListWorkflowByMachine } from "../../services/ReduxTookit/Slice/CostManagementRedux";
import moment from "moment";
import { commonservices } from "../../services/CommonServices";
const ChargeByMachine = ({ data, startDate, endDate, mainLoading }) => {
  
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);

  
  const handleShowCollapse = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  const MachineDataList = useSelector(
    (state) =>
      state?.costmanagement?.ChargesListWorkflowByMachineData?.data?.data?.data
        ?.dataList1
  );
  

  useEffect(() => {
    if (expandedRow) {
      setLoading(true);
      dispatch(
        ChargesListWorkflowByMachine({
          startdate: moment(startDate).format("YYYY-MM-DD"),
          enddate: moment(endDate).format("YYYY-MM-DD"),
          machineid: expandedRow,
        })
      )?.then(() => setLoading(false));
    }
  }, [expandedRow, startDate, endDate]);
  return (
    <div className="table-wrapper-main">
      <Table responsive>
        <thead>
          <th>Description</th>
          <th className="width175 text-center">Usage</th>
          <th className="text-end width125">Invoice Amount</th>
        </thead>
        <tbody>
          {mainLoading ? (
            <Loader type={LoaderType.TableRow} count={4} nooftd={3} />
          ) : (
            <>
              {["Starter", "Other", "Exit"]
                ?.flatMap((cat) =>
                  data?.filter((itm) =>
                    cat === "Other"
                      ? itm?.machinename?.toUpperCase() !== "STARTER" &&
                        itm?.machinename?.toUpperCase() !== "EXIT"
                      : itm?.machinename === cat
                  )
                )
                ?.map((item, index) => {
                  const isExpanded = expandedRow === item?.machineid;

                  return (
                    <React.Fragment key={item?.machineid}>
                      <tr className="dark-bg">
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <>
                              <img
                                src={isExpanded ? minusIcon : addIcon}
                                alt="toggleIcon"
                                className="cursor-pointer"
                                onClick={() =>
                                  handleShowCollapse(item?.machineid)
                                }
                              />
                              <span>{item?.machinename}</span>
                            </>
                          </div>
                        </td>
                        <td>
                          {commonservices.calculateDurationSec(
                            parseInt(item?.totaltime)
                          )}
                        </td>
                        <td>
                          ${" "}
                          {item?.consumptioncost
                            ? commonservices.fnAmountDigitCount(
                                item?.consumptioncost,
                                5
                              )
                            : 0.0}
                        </td>
                      </tr>
                      {loading && isExpanded ? (
                        <Loader
                          type={LoaderType.TableRow}
                          count={4}
                          nooftd={3}
                        />
                      ) : (
                        <>
                          {" "}
                          {isExpanded &&
                            MachineDataList?.map((item_2, index_2) => {
                              return (
                                <tr className="dark-bg child-row">
                                  <td>
                                    <div>
                                      <span>{item_2?.workflowname}</span>
                                    </div>
                                  </td>
                                  <td>
                                    {commonservices.calculateDurationSec(
                                      parseInt(item_2?.sum)
                                    )}
                                  </td>
                                  <td>
                                    ${" "}
                                    {item_2?.consumptioncost
                                      ? commonservices.fnAmountDigitCount(
                                          item_2?.consumptioncost,
                                          5
                                        )
                                      : 0.0}
                                  </td>
                                </tr>
                              );
                            })}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
            </>
          )}
          {!mainLoading && (
            <tr className="dark-bg">
              <td>
                <b>Total</b>
              </td>
              <td></td>
              <td>
                ${" "}
                {commonservices.fnAmountDigitCount(
                  data?.reduce(
                    (total, items) =>
                      total + (parseFloat(items?.consumptioncost) || 0),
                    0
                  ),
                  5
                )}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ChargeByMachine;
